import Field from "@js/core/field.es6.js";
import PatientInsuranceOptionsParagraph from "@js/paragraphs/patient-insurance-options-paragraph.es6.js";

export default class PatientInsuranceOptionsParagraphField extends Field {
  constructor({ machineName, parentElement }) {
    super({
      machineName,
      parentElement,
    });
  }

  get paragraph() {
    return new PatientInsuranceOptionsParagraph({
      parentElement: this,
    });
  }
}
